<template>
  <div class="list">
    <sr-loading v-if="loading"/>
    <div v-else>
      <div class="tab">
        <el-radio-group size="small" v-model="queryForm.baseType" @change="tabChange">
          <el-radio-button :label="item.label" v-for="item in tabData" :key="item.label">{{item.text}}</el-radio-button>
        </el-radio-group>
      </div>
      <sr-list>
        <sr-list-item v-for="(item, index) in listData" :key="index" :img="item.defaultImage" :go="item.uuid" @click="go">
          <div class="sr-list-txt">
            <p class="p1">{{item.brandNameEn}} / {{item.brandName}}</p>
            <p class="p2" :title="item.name">{{item.name}}</p>
            <p class="p3">{{item.currentPrice | money}}</p>
            <p class="p4">{{item.basicPrice | money}}</p>
          </div>
        </sr-list-item>
      </sr-list>
      <div class="page" v-if="total > 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryForm.pageNum"
          :page-size="queryForm.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import SrLoading from '@/components/loading'
  import srList from '@/components/list'
  import srListItem from '@/components/list/item'
  export default {
    components: {
      SrLoading,
      srList,
      srListItem
    },
    data () {
      return {
        loading: true,
        tabData: [{
          label: 1,
          text: '最新上市'
        }, {
          label: 4,
          text: '价格由高到低'
        }, {
          label: 3,
          text: '价格由底到高'
        }],
        listData: [],
        queryForm: {
          pageNum: 1,
          pageSize: 20,
          productType: 1, // 1为奢侈品列表 3为餐券列表 （默认为奢侈品列表）
          baseType: 1 // 1 按时间顺序 2 按时间倒序 3 按价格正序 4按价格倒序 5 按促销折扣从大到小 6按促销折扣从小到大 7 按库存顺序 8按库存倒序 9按销量顺序 10按销量倒序
        },
        total: 0
      }
    },
    methods: {
      go (v) {
        this.$router.push({
          path: '/list-detail/' + v
        })
      },
      goTop () {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      },
      tabChange (v) {
        this.queryForm.pageNum = 1
        this.queryForm.baseType = v
        this.selectProductSpuList()
      },
      handleSizeChange (v) {
        this.queryForm.pageSize = v
        this.selectProductSpuList()
      },
      handleCurrentChange (v) {
        this.goTop()
        this.queryForm.pageNum = v
        this.selectProductSpuList()
      },
      selectProductSpuList () {
        this.loading = true
        let id = this.$route.query.id
        let type = this.$route.params.type
        if (type === 'category') {
          this.$set(this.queryForm, 'entityIds', id)
          this.$delete(this.queryForm, 'brandId', id)
        } else if (type === 'brand') {
          this.$delete(this.queryForm, 'entityIds', id)
          this.$set(this.queryForm, 'brandId', id)
        }
        axios.get('/api/productSpuController/selectProductSpuList', {
          params: this.queryForm
        }).then((res) => {
          if (res.data.code === 9999) {
            this.listData = res.data.data.list
            this.total = res.data.data.total
            this.loading = false
          }
        })
      }
    },
    created () {
      this.selectProductSpuList()
    },
    watch: {
      '$route' (v) {
        this.goTop()
        this.queryForm.baseType = 1
        this.queryForm.pageNum = 1
        this.selectProductSpuList()
      }
    }
  }
</script>

<style lang="less" scoped>
  .list {
    width: 1200px;
    margin: 0 auto;
    .tab {
      padding: 20px 0 0 10px;
    }
    .sr-list-txt {
      height: 90px;
      line-height: 20px;
      text-align: center;
      p {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .p1, .p4 {
        font-size: 12px;
      }
      .p1 {
        color: #666;
      }
      .p2 {
        color: #333;
        padding-bottom: 10px;
      }
      .p3 {
        color: #cdad66;
      }
      .p4 {
        color: #ccc;
        text-decoration: line-through;
      }
    }
    .page {
      text-align: center;
      padding:10px 0 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/list/index.vue